import {
    ADDITIONAL_EMAILS_RESOURCE_NAME,
    MAX_CHATS_RESOURCE_NAME,
    TELEGRAM_CHATS_RESOURCE_NAME,
} from 'shared/config/model/urls';

import {t} from '@lingui/core/macro';

import {IUserOutput, hasTariffFlag} from 'entities/user';
import CreateDomainMonitorType from 'features/domain/model/DomainMonitor/CreateDomainMonitorType';
import {idsToIri} from 'shared/api/iriHelper';
import {isTranslate} from 'shared/lib/lang';
import {DOMAIN_CHECK_KEYS, DomainCheckKey, getDomainCheckCondition, getDomainCheckLabel} from 'entities/monitor';

export type DomainBatchEditFormValues = Omit<CreateDomainMonitorType, 'domain'>;

export type DomainBatchEditFieldKey = DomainCheckKey | 'notify';

export interface IDomainBatchEditField {
    key: DomainBatchEditFieldKey;
    label: () => string;
    formKeys: (keyof DomainBatchEditFormValues)[];
    isAvailable: (_user: IUserOutput | null) => boolean;
}

export const DOMAIN_BATCH_EDIT_FIELDS: IDomainBatchEditField[] = [
    ...DOMAIN_CHECK_KEYS.map((key): IDomainBatchEditField => ({
        key,
        label: () => getDomainCheckLabel(key),
        formKeys: [key],
        isAvailable: (user) => hasTariffFlag(user, getDomainCheckCondition(key))
            && (key !== 'rkn_watch' || !isTranslate()),
    })),
    {
        key: 'notify',
        label: () => t`Уведомления`,
        formKeys: ['notify_by_email', 'additional_emails', 'telegram_chats', 'max_chats'],
        isAvailable: () => true,
    },
];

export const DOMAIN_BATCH_EDIT_FIELD_BY_KEY: Record<string, IDomainBatchEditField> = DOMAIN_BATCH_EDIT_FIELDS
    .reduce(
        (acc, field) => {
            acc[field.key] = field;
            return acc;
        },
        {} as Record<string, IDomainBatchEditField>,
    );

const IRI_RESOURCE: Partial<Record<keyof DomainBatchEditFormValues, string>> = {
    telegram_chats: TELEGRAM_CHATS_RESOURCE_NAME,
    max_chats: MAX_CHATS_RESOURCE_NAME,
    additional_emails: ADDITIONAL_EMAILS_RESOURCE_NAME,
};

export function buildDomainBatchEditPayload(
    addedFields: string[],
    formData: DomainBatchEditFormValues,
    selectedIds: string[],
): Record<string, unknown> {
    const data: Record<string, unknown> = {ids: selectedIds};

    const activeFormKeys = new Set<keyof DomainBatchEditFormValues>();
    addedFields.forEach(key => {
        const field = DOMAIN_BATCH_EDIT_FIELD_BY_KEY[key];
        if (field) {
            field.formKeys.forEach(formKey => activeFormKeys.add(formKey));
        }
    });

    activeFormKeys.forEach(formKey => {
        const resource = IRI_RESOURCE[formKey];
        if (resource) {
            data[formKey] = idsToIri((formData[formKey] as unknown) as string[], resource);
            return;
        }
        data[formKey] = formData[formKey];
    });

    return data;
}
